export class Center {
    Id:Number ;
	CentreName: String;
	CentreCode: String;
	BranchId:Number ;
	LeaderName:String ;
	AsstLeaderName:String ;
	ContactName: String;
	BranchManagerName:String ;
	CreditExecutiveName:String ;
	ContactNo:Number ;
	MaxMembers:Number ;
	MaxGroups: String;
	Distancefrombranch: String;
	LocationName: String;
	LocationLandMark: String;
	MeetingDay: string;
	CollectionTypeId:Number ;
	CollectionPlace: String;
	CollectionTime:String ;
	BankDetails: String;
	EmployeeId:Number ;
	EmployeeBranchId:Number ;
	CompanyId:Number ;
	SaasId:Number ;
	CreatedDate:Date ;
	ModifiedDate:Date ;
    IsActive:Number ;
    Flag:Number ;
}
